import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold py-4 fs-6 w-275px",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "menu-item px-3" }
const _hoisted_3 = { class: "menu-content d-flex align-items-center px-3" }
const _hoisted_4 = { class: "symbol symbol-50px me-5" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "d-flex flex-column" }
const _hoisted_7 = { class: "fw-bolder d-flex align-items-center fs-5" }
const _hoisted_8 = {
  href: "#",
  class: "fw-bold text-muted text-hover-primary fs-7"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_10 = { class: "menu-item px-5" }
const _hoisted_11 = { class: "menu-item px-5" }
const _hoisted_12 = { class: "menu-item px-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: 
              this.userInfo?.employee?.attach_file_info?.file_path
                ? _ctx.api_url + this.userInfo?.employee?.attach_file_info?.file_path
                : 'media/avatars/blank.png'
            
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(this.userInfo?.employee?.name), 1),
          _createElementVNode("a", _hoisted_8, _toDisplayString(this.userInfo?.employee?.email), 1)
        ])
      ])
    ]),
    _hoisted_9,
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_router_link, {
        to: "/user/show-profile",
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" My Profile ")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_router_link, {
        to: "/user/change-password",
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Change Password ")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.signOut())),
        class: "menu-link px-5"
      }, " Sign Out ")
    ])
  ]))
}